import type { CheckboxChangeEvent } from "antd/es/checkbox";
import i18n from "i18next";
import type { FC } from "react";

import { CheckboxInputStyle } from "../../../../documentation/styles/InputStyle";
import type { AntCustomFormField } from "../../types/types";

interface CheckBoxInputProps extends AntCustomFormField<boolean> {
    name: string;
    label: string;
    readOnly: boolean;
    defaultChecked?: boolean;
}

export const Checkbox: FC<CheckBoxInputProps> = ({ onChange, value, label, readOnly, defaultChecked, ...restProps }) => {
    const onValueChange = (ev: CheckboxChangeEvent) => {
        if (onChange) {
            onChange(ev.target.checked);
        }
    };

    const className = `
        aevi-input-checkbox
        ${readOnly ? " aevi-checkbox-disabled" : ""}
        ${value ? " aevi-input-checkbox-marked" : ""}
    `;

    return (
        <CheckboxInputStyle
            className={className}
            checked={value || false}
            disabled={readOnly}
            onChange={onValueChange}
            defaultChecked={defaultChecked}
            {...restProps}
        >
            {i18n.t(label, { defaultValue: "" })}
        </CheckboxInputStyle>
    );
};
